import { makeStyles,withStyles } from "@material-ui/core/styles";
import { red,lightBlue ,indigo} from "@material-ui/core/colors";
import { Chip } from "@material-ui/core";
export const BillingStyles = makeStyles(theme => ({
  centerTitle: {
    display:"flex" ,
    justifyContent:"center",
    textAlign:"center"
  },
  amoutColorRed: {
    color: theme.palette.eDanger?.dark
  },
  amoutColorGreen: {
    color: theme.palette.eSecondary?.base,
  },
  amountColorGrey:{
    color: theme.palette.eDark?.base,
  },
  linkpay: {
    color: theme.palette.tertiary.main,
    marginLeft: "10px",
   "&:hover":{
      color: theme.palette.tertiary.main,
    }
  },
  linkFaq: {
    color: theme.palette.tertiary.main,
  },
  forthButton:{
    color: theme.palette.eWhite?.base+" !important",
  },
  chipColorRed: {
    background: theme.palette.eDanger?.dark+" !important"
  },
  chipColorBlue:{
    background:indigo.A100+" !important",
    color:indigo[900]+" !important"
  },
  loadingButton:{
    color:theme.palette.grey[500] + "!important"
  }
}));
 
export const CustomiseChip = withStyles(theme => ({
  root: {
    fontSize: theme.typography.pxToRem(11),
    borderRadius:'0px !important',
    padding:'0% !important'
  },
  label:{
    padding:"4px !important",
  }
}))(Chip);